import apiService from './api';
import { DashboardStats, DailyMetric } from '../types/models';

export const analyticsDashboardService = {
  getDashboardStats: (days: number = 30) =>
    apiService.get<DashboardStats>(`/analytics/dashboard?days=${days}`),

  getDailyMetrics: (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    const query = params.toString();
    return apiService.get<DailyMetric[]>(
      query ? `/analytics/metrics/daily?${query}` : '/analytics/metrics/daily'
    );
  },
};

export default analyticsDashboardService;
